import jquery from "jquery/dist/jquery";

globalThis.jQuery = jquery;
globalThis.$ = jquery;
